// @flow
import { connect } from "react-redux";

import { showModal, closeModal } from "../actions/Modals";

import type { ReduxState, ShowModalAction, CloseModalAction } from "../types";
import type { ComponentType } from "react";

type StateProps = {
  visibleModalKey: string | null,
  visibleModalSize?: string | null,
};

type DispatchProps = {
  onShowModal: (modalKey: string) => ShowModalAction,
  onCloseModal: (modalKey: string) => CloseModalAction,
};

type Props = {
  ...StateProps,
  ...DispatchProps,
};

const mapStateToProps = (state: ReduxState): StateProps => {
  const visibleModal = state.modals.modals.find((modal) => modal.visible);

  return {
    visibleModalKey: visibleModal ? visibleModal.key : null,
    visibleModalSize: visibleModal ? visibleModal.size : null,
  };
};

const mapDispatchToProps = {
  onShowModal: showModal,
  onCloseModal: closeModal,
};

/**
 * @deprecated - will be removed in the future, use the equivalent hook 'useModal' instead
 */
export const connectModal: ComponentType<any> = connect<
  Props,
  {},
  StateProps,
  _,
  _,
  _,
>(mapStateToProps, mapDispatchToProps);
